// extracted by mini-css-extract-plugin
export default {"containerRegistro":"SectionRegister_containerRegistro__8Lpiq","section":"SectionRegister_section__eVPVj","containerExtra":"SectionRegister_containerExtra__ewLMK"};